import React, { useEffect, useMemo, useState } from "react";
import { Select, Skeleton,Grid } from "antd";
import "./orderbook-ant.css";
import { L1, L3, L4 } from "../SvgCollections";
const { Option } = Select;

const { useBreakpoint } = Grid;

export default function OrderBook({
    height = "100%",
    midPrice = 87500.7,
    asks = [],
    bids = [],
    loading = false,
}) {
    const screen = useBreakpoint()
    const [bookMode, setBookMode] = useState("both"); // both | bids | asks
    const [activeMode, setActiveMode] = useState(0);
    const [depthValue, setDepthValue] = useState(2);
    console.log(bids, 'bidask');

    // Compute max depth for shading
    const maxTotal = useMemo(() => {
        const askTotals = asks.reduce((acc, [p, q]) => {
            const total = (acc.length ? acc[acc.length - 1] : 0) + parseFloat(q);
            acc.push(total);
            return acc;
        }, []);

        const bidTotals = bids.reduce((acc, [p, q]) => {
            const total = (acc.length ? acc[acc.length - 1] : 0) + parseFloat(q);
            acc.push(total);
            return acc;
        }, []);

        return Math.max(...askTotals, ...bidTotals, 1);
    }, [asks, bids]);

    return (
        <div className="orderbook-wrapper" style={{ height }}>
            {loading ? (
                <Skeleton active paragraph={{ rows: 10 }} />
            ) : (
                <>
                 

                    <div className="orderbook-top">
                        <div className="icon-tabs">
                            <div
                                className={`tab-icon ${bookMode === "both" ? "active" : ""}`}
                                onClick={() => setBookMode("both")}
                            >
                                <L1 />
                            </div>

                            <div
                                className={`tab-icon ${bookMode === "bids" ? "active" : ""}`}
                                onClick={() => setBookMode("bids")}
                            >
                                <L3 />
                            </div>
                            <div
                                className={`tab-icon ${bookMode === "asks" ? "active" : ""}`}
                                onClick={() => setBookMode("asks")}
                            >
                                <L4 />
                            </div>
                        </div>

                        <Select
                            size="small"
                            value={depthValue}
                            style={{ width: 80 }}
                            onChange={(v) => setDepthValue(v)}
                            className="tab-book"
                        >
                            <Option value={2}>0.01</Option>
                            <Option value={3}>0.001</Option>
                            <Option value={4}>0.0001</Option>
                        </Select>
                    </div>
                    {/* COLUMN HEADINGS */}
                    <div className="orderbook-header">
                        <div className="cell price">Price</div>
                        { <div className="cell amount">Quantity</div>}
                     { screen.lg &&   <div className="cell total">Total</div>}
                    </div>
                    {/* Asks (Sell orders) */}
                    {(bookMode === "both" || bookMode === "asks") && (
                        <div className="orderbook-section asks">
                            {asks.map((row, i) => {
                                const [price, quantity] = row;
                                return (
                                    <div className="ob-row" key={`ask-${i}`}>
                                        <div
                                            className="depth-bar red"
                                            style={{
                                                width: `${(asks.slice(0, i + 1).reduce((t, [p, q]) => t + parseFloat(q), 0) / maxTotal) * 100}%`
                                            }}
                                        />
                                        <div className="cell price red-text">{parseFloat(price).toFixed(2)}</div>
                                      { <div className="cell amount">{parseFloat(quantity).toFixed(2)}</div>}
                                    {screen.lg &&  <div className="cell total">{(parseFloat(price) * parseFloat(quantity)).toFixed(2)}</div>}
                                    </div>
                                );
                            })}
                        </div>
                    )}


                    {/* MID PRICE */}
                    {bookMode === "both" && (
                        <div className="mid-price">
                            {midPrice.toLocaleString()}
                            <span className="mid-usd">≈ {midPrice.toLocaleString()} USD</span>
                        </div>
                    )}


                    {/* Bids (Buy orders) */}
                    {(bookMode === "both" || bookMode === "bids") && (
                        <div className="orderbook-section bids">
                            {bids.map((row, i) => {
                                const [price, quantity] = row;
                                return (
                                    <div className="ob-row" key={`bid-${i}`}>
                                        <div
                                            className="depth-bar green"
                                            style={{
                                                width: `${(bids.slice(0, i + 1).reduce((t, [p, q]) => t + parseFloat(q), 0) / maxTotal) * 100}%`
                                            }}
                                        />
                                        <div className="cell price green-text">{parseFloat(price).toFixed(2)}</div>
                                        <div className="cell amount">{parseFloat(quantity).toFixed(2)}</div>
                                      {screen.lg &&   <div className="cell total">{(parseFloat(price) * parseFloat(quantity)).toFixed(2)}</div>}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                </>
            )}
        </div>
    );
}
